import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PageShell, { Reveal, SectionHeading } from "../components/PageShell";
import { skillGroups, proofOfWork } from "../data/skills";
import { languages } from "../data/profile";
import "../styles/Skills.scss";

function Skills() {
  const [active, setActive] = useState("all");
  const groups = active === "all" ? skillGroups : skillGroups.filter((g) => g.key === active);
  const total = skillGroups.reduce((n, g) => n + g.items.length, 0);

  return (
    <PageShell slug="skills">
      <section>
        <SectionHeading eyebrow={`Toolbox · ${total} technologies`} title="The stack I reach for" />

        <div className="filter-chips">
          <button className={active === "all" ? "is-active" : ""} onClick={() => setActive("all")}>
            All <span>{total}</span>
          </button>
          {skillGroups.map((g) => (
            <button
              key={g.key}
              className={active === g.key ? "is-active" : ""}
              onClick={() => setActive(g.key)}
            >
              {g.title}
              <span>{g.items.length}</span>
            </button>
          ))}
        </div>

        <div className="skill-groups">
          {groups.map((g) => (
            <motion.div
              key={g.key}
              className="skill-group"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h3 className="skill-group-title">{g.title}</h3>
              <ul className="skill-tiles">
                {g.items.map(({ name, icon: Icon, color }) => (
                  <li key={name} className="skill-tile" style={{ "--brand": color }}>
                    <Icon aria-hidden="true" />
                    <span>{name}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </section>

      <section>
        <SectionHeading eyebrow="Proof of work" title="Where each skill was actually used">
          No self-rated progress bars — just the projects behind the claims.
        </SectionHeading>
        <div className="proof-table" role="table">
          <div className="proof-row proof-head" role="row">
            <span role="columnheader">Skill</span>
            <span role="columnheader">What I built with it</span>
            <span role="columnheader">Where</span>
          </div>
          {proofOfWork.map((p, i) => (
            <Reveal key={p.skill} className="proof-row" role="row" delay={i * 0.04}>
              <span className="proof-skill" role="cell">
                {p.skill}
              </span>
              <span className="proof-context" role="cell">
                {p.context}
              </span>
              <span className="proof-where" role="cell">
                {p.where.map((w) => (
                  <Link key={w} to="/projects">
                    {w}
                  </Link>
                ))}
              </span>
            </Reveal>
          ))}
        </div>
      </section>

      <section>
        <SectionHeading eyebrow="Languages" title="How I communicate" />
        <div className="grid-2">
          {languages.map((l) => (
            <Reveal key={l.name} className="card lang-card">
              <span className="lang-name">{l.name}</span>
              <span className="badge">{l.level}</span>
            </Reveal>
          ))}
        </div>
      </section>
    </PageShell>
  );
}

export default Skills;
